import { Component } from "react";
import "./Toast.css";

/**
 * Simple toast notification component.
 * Auto-dismisses after a specified duration.
 */
class Toast extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            message: "",
            type: "info" // info, success, warning, error
        };
        this.timeoutId = null;
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    show(message, type = "info", duration = 3000) {
        // Clear any existing timeout
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }

        this.setState({ visible: true, message, type });

        this.timeoutId = setTimeout(() => {
            this.setState({ visible: false });
        }, duration);
    }

    hide() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.setState({ visible: false });
    }

    render() {
        const { visible, message, type } = this.state;

        if (!visible) return null;

        return (
            <div className={`toast-notification toast-${type}`}>
                <span className="toast-message">{message}</span>
            </div>
        );
    }
}

export default Toast;
